export default {
  update(state, info) {
    state.info = info && info.uid > 0 ? info : null
  }
}
